export default __webpack_public_path__ + "static/media/nlike.4afddb22.svg";